import { render, staticRenderFns } from "./TabsPlaceHolder.vue?vue&type=template&id=2637f0d1&scoped=true"
import script from "./TabsPlaceHolder.vue?vue&type=script&lang=js"
export * from "./TabsPlaceHolder.vue?vue&type=script&lang=js"
import style0 from "./TabsPlaceHolder.vue?vue&type=style&index=0&id=2637f0d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2637f0d1",
  null
  
)

export default component.exports